import React from "react";
import ReactDOM from "react-dom";
import styles from "./Library.module.css";

type LibraryDialogProps = {
  isVisible: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  size?: "default" | "wide";
};

const LibraryDialog = ({ isVisible, title, onClose, children, size = "default" }: LibraryDialogProps) => {
  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div className={styles.dialogBackdrop} onClick={onClose} role="presentation">
      <div
        className={`${styles.dialogPanel} ${size === "wide" ? styles.dialogWide : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.dialogHeader}>
          <h2>{title}</h2>
          <button type="button" className={styles.iconButton} onClick={onClose} aria-label="Close">
            <img src="/img/close.svg" alt="" />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default LibraryDialog;
